import axios from 'axios';
import { config } from '../../config';

export const get_pending_merge = (entityType, recordId) => {
    return axios.get(`${config.NIFFLER_BACKEND_URL}/prospects/pendingMerge`, {
        params: { entityType, recordId },
        timeout: 30000
    }).then(response => response.data.data);
};

export const search_merge_records = (entityType, search, excludeId) => {
    return axios.get(`${config.NIFFLER_BACKEND_URL}/prospects/searchMergeRecords`, {
        params: { entityType, search, excludeId },
        timeout: 30000
    }).then(response => response.data.data.records);
};

export const preview_merge_records = (entityType, survivorId, sourceId) => {
    return axios.post(`${config.NIFFLER_BACKEND_URL}/prospects/previewMerge`, {
        entityType, survivorId, ...(Array.isArray(sourceId) ? { sourceIds: sourceId } : { sourceId })
    }).then(response => response.data.data);
};

export const merge_records = (preview, choices) => {
    return axios.post(`${config.NIFFLER_BACKEND_URL}/prospects/mergeRecords`, {
        entityType: preview.entityType,
        survivorId: preview.survivor.id,
        ...(preview.sources?.length ? { sourceIds: preview.sources.map(source => source.id) } : { sourceId: preview.source.id }),
        previewToken: preview.previewToken,
        choices
    }).then(response => response.data.data);
};
